import { utils } from '@hh/global.js'

const { prefersReducedMotion } = utils

function initVideos() {
  const htmlPlayers = document.querySelectorAll('.js-player')

  if (htmlPlayers) {
    const plyrPlayers = Array.from(htmlPlayers).map((p) => {
      const settings = {
        i18n: {
          play: 'watch',
        },
        loadSprite: false,
        iconUrl: '#icon-play',
        controls: [
          'play',
          'play-large',
          'progress',
          'current-time',
          'mute',
          'volume',
          'airplay',
        ],
      }

      if (p.classList.contains('player--autoplay')) {
        settings.autoplay = true
        settings.loop = {}
        settings.loop.active = true
        settings.muted = true
      }

      return new Plyr(p, settings)
    })

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          entry.target.classList.contains('player--autoplay') &&
          !prefersReducedMotion()
        ) {
          let interval = setInterval(() => {
            if (
              typeof entry.target.plyr.elements.buttons.play !== 'undefined'
            ) {
              entry.target.plyr.play()
              clearInterval(interval)
            }
          }, 500)
        } else {
          entry.target.plyr.pause()
        }
      })
    })

    htmlPlayers?.forEach((player) => {
      observer.observe(player)
    })
  }
}

/**
 * https://developer.apple.com/forums/thread/651215
 * "It checks to see if DOMContentLoaded has already been fired (hence the document is no longer loading),
 * and if so, run the code. If it has not been fired yet, then the listener is initialized."
 *
 * However, without wrapping in the `if(isSafari)`, Chrome would enter the `document.readyState !== 'loading`
 * scope, even though DOMContent *hadn't* loaded.
 *
 * ¯\_(ツ)_/¯
 */
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
if (isSafari && document.readyState !== 'loading') {
  initVideos()
} else {
  document.addEventListener('DOMContentLoaded', () => {
    initVideos()
  })
}
